import AppConstants from '../constants/app.constants'
import { userService } from './user.service'
import HTTPClient from '../common/http-client'
import WindowUtils from '../_helpers/window.util'
import { store } from '@/store.js'
import msalInstance from '../entra-login/entra.config.js'
import ErrorMessageUtils from '../_helpers/error-message.util'
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
export const authService = {
  login,
  logout,
  verifyEntraLogin,
  handleEntraLogout
}

const DEFAULT_ERROR_MSG = 'Failed to login'

async function login(username, password, isRememberMe) {
  const requestBody = { username, password }
  // Send request to authentication server (refer to config/index.js file for proxy configuration)
  const response = await HTTPClient.getInstance().httpLogin.post('/login', requestBody)
  const data = response.data
  if (!data) {
    return DEFAULT_ERROR_MSG
  }
  // Return error message if any
  if (data.code === 401 || data.code === 500) {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_LOGIN_ID_OR_PASSWORD_INCORRECT_ERR_CD,
      ErrorCdMsgConstants.FUNC_LOGIN_ID_OR_PASSWORD_INCORRECT_ERR_MSG
    )
  }

  // Store token in the storage if it's available
  if (data.token) {
    if (isRememberMe) {
      localStorage.setItem(AppConstants.TOKEN, data.token)
      localStorage.setItem(AppConstants.STORAGE_LOGIN_MODE, AppConstants.SYSTEM_LOGIN_MODE)
      const userDetails = await userService.getUserInfo()
      if (userDetails) {
        localStorage.setItem(
          AppConstants.USER_DETAILS,
          JSON.stringify(userDetails)
        )
      }
    } else {
      sessionStorage.setItem(AppConstants.TOKEN, data.token)
      sessionStorage.setItem(AppConstants.STORAGE_LOGIN_MODE, AppConstants.SYSTEM_LOGIN_MODE)
      const userDetails = await userService.getUserInfo()
      if (userDetails) {
        sessionStorage.setItem(
          AppConstants.USER_DETAILS,
          JSON.stringify(userDetails)
        )
      }
    }
    return null
  }

  return DEFAULT_ERROR_MSG
}

/**
 * ログアウト処理を行う非同期関数。
 */
async function logout() {
  try {
    const isSystemSessionStorageLogin = sessionStorage.getItem(AppConstants.STORAGE_LOGIN_MODE) === AppConstants.SYSTEM_LOGIN_MODE
    if (isSystemSessionStorageLogin) {
      sessionStorage.removeItem(AppConstants.TOKEN)
      sessionStorage.removeItem(AppConstants.STORAGE_LOGIN_MODE)
      sessionStorage.removeItem(AppConstants.USER_DETAILS)
      WindowUtils.closeWindow(AppConstants.CHUTE_GRID_WINDOW)
      return
    }
    const isEntraLogin = localStorage.getItem(AppConstants.STORAGE_LOGIN_MODE) === AppConstants.ENTRA_LOGIN_MODE
    if (isEntraLogin) {
      store.commit('setIsLoadingLogoutEntra', true)
      localStorage.setItem(AppConstants.STOP_INTERVAL_API_FLAG, 'true')
      // Entraログインの場合、ログインタイムスタンプを削除
      localStorage.removeItem(AppConstants.STORAGE_LOGIN_TIMESTAMP)
      await handleEntraLogout().catch(error => {
        console.log(error)
      })
      localStorage.removeItem(AppConstants.STORAGE_ACTIVE_ACCOUNT_ENTRA)
    }
    // ログアウトするためにローカルストレージからユーザーを削除
    localStorage.removeItem(AppConstants.TOKEN)
    localStorage.removeItem(AppConstants.USER_DETAILS)
    localStorage.removeItem(AppConstants.CHANGE_PASSWORD_MODE)
    localStorage.removeItem(AppConstants.STORAGE_LOGIN_MODE)
    store.dispatch('settingWizardStore/removeSetupStatusProp', { root: true })
    store.dispatch('settingWizardStore/updateMenuStatus', 0, { root: true })
    store.dispatch('devSettingStore/updateDevSettingMode', 0)
    WindowUtils.closeWindow(AppConstants.CHUTE_GRID_WINDOW)
  } catch (error) {
    console.log(error)
  } finally {
    store.commit('setIsLoadingLogoutEntra', false)
    localStorage.removeItem(AppConstants.STOP_INTERVAL_API_FLAG)
  }
}

/**
 * Entraログインを検証する非同期関数。
 * @param {string} accessToken - Entraからのアクセストークン
 * @param {string} tenantId - EntraのテナントID
 * @returns {Promise<string|null>} エラーメッセージまたはnull
 */
async function verifyEntraLogin(accessToken, tenantId) {
  const requestBody = { accessToken, tenantId }
  const response = await HTTPClient.getInstance().httpLogin.post('/verify-entra-login', requestBody)
  const data = response.data
  if (!data) {
    return DEFAULT_ERROR_MSG
  }
  // エラーメッセージがある場合は返す
  if (data.code === AppConstants.RESPONSE_401_ERROR_CODE || data.code === AppConstants.RESPONSE_500_ERROR_CODE) {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_HUB_LOCATION_LOGIN_RESTRICTED_ERR_CD,
      ErrorCdMsgConstants.FUNC_HUB_LOCATION_LOGIN_RESTRICTED_ERR_MSG
    )
  }

  // トークンが利用可能な場合は、ストレージに保存します
  if (data.code === AppConstants.RESPONSE_200_OK_CODE) {
    localStorage.setItem(AppConstants.TOKEN, accessToken)
    localStorage.setItem(AppConstants.STORAGE_LOGIN_MODE, AppConstants.ENTRA_LOGIN_MODE)
    const userDetails = data.data
    if (userDetails) {
      localStorage.setItem(
        AppConstants.USER_DETAILS,
        JSON.stringify(userDetails)
      )
    }
    return null
  }

  return DEFAULT_ERROR_MSG
}

/**
 * Entraログアウトを処理する非同期関数。
 */
async function handleEntraLogout() {
  const activeAccount = msalInstance.getActiveAccount()
  let logoutHint = activeAccount?.idTokenClaims?.login_hint
  if (!logoutHint) {
    const res = await msalInstance.acquireTokenSilent({
      scopes: ['openid', 'profile'],
      activeAccount
    })
    logoutHint = res?.account?.idTokenClaims?.login_hint
  }
  await msalInstance?.logoutPopup({
    logoutHint: logoutHint
  })
}



// WEBPACK FOOTER //
// ./src/_services/auth.service.js